//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  parseDateYYYYMMDD,
  formatDateDDMMYYYY,
} from '../../../../common/functions/date-utils';
import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'CalendarioForm',
  components: {
    Confirm,
  },
  props: {
    idEvento: {
      type: Number,
      default: null,
    },
    somenteLeitura: true,
  },
  data() {
    return {
      resources: this.$api.calendario(this.$resource),
      tipos: [],
      menuDataInicio: false,
      menuCor: false,
      menuDataFim: false,
      observacoes: null,
      eventosListados: [],
      cores: [
        'red darken-1',
        'deep-purple darken-1',
        'blue darken-1',
        'light-blue darken-1',
        'cyan darken-1',
        'teal darken-1',
        'green darken-1',
        'light-green darken-1',
        'lime darken-1',
        'yellow darken-1',
        'amber darken-1',
        'orange darken-1',
        'deep-orange darken-1',
        'blue-grey darken-1',
        'grey darken-1',
      ],
      evento: {
        id: null,
        nome: '',
        dataInicio: null,
        dataFim: null,
        dataDiaSeguinte: null,
        idTipo: null,
        cor: 'red darken-1',
        indAtivo: true,
      },
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        requiredTipo: () => !!(this.evento.idTipo) || this.$t('message.campo_obrigatorio'),
        maxLength50: v => (v && v.length <= 50) || this.$t('message.limite_caracteres_excedido'),
        validDate: value => (!value || (value.length === 10 && this.moment(value, 'DD-MM-YYYY').isValid())) || this.$t('message.data_invalida'),
        dataFimMaiorInicio: () => !this.isDataFimMaiorInicio() || this.$t('message.data_inicial_maior_final'),
        dataInicioMenorQueDiaSeguinte: () => !this.isDataInicioMenorDiaSeguinte() || this.$t('message.data_inicial_menor_dia_seguinte'),
      },
    };
  },
  computed: {
    dateInicioFormatada: {
      get() {
        return formatDateDDMMYYYY(this.evento.dataInicio);
      },
      set(newValue) {
        this.evento.dataInicio = parseDateYYYYMMDD(newValue);
      },
    },
    dataInicio: {
      get() {
        return this.evento.dataInicio;
      },
      set(newValue) {
        this.evento.dataInicio = newValue;
      },
    },
    dateFimFormatada: {
      get() {
        return formatDateDDMMYYYY(this.evento.dataFim);
      },
      set(newValue) {
        this.evento.dataFim = parseDateYYYYMMDD(newValue);
      },
    },
    dataFim: {
      get() {
        return this.evento.dataFim;
      },
      set(newValue) {
        this.evento.dataFim = newValue;
      },
    },
    dataDiaSeguinte: {
      get() {
        return `${this.moment().add(1, 'd').format('YYYY-MM-DD')}`;
      },
      set(newValue) {
        this.evento.dataDiaSeguinte = formatDateDDMMYYYY(newValue);
      },
    },
  },
  methods: {
    abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      this.$refs.confirmDialog.open();
    },
    salvar() {
      if (this.idEvento) {
        this.resources.atualizar({ id: this.idEvento }, this.evento).then(() => {
          this.$toast.create(this.$t('message.atualizado_confira_tabela'), 'snack', '3E3');
          this.$emit('atualizarGrid');
        }, (err) => {
          this.$error(this, err);
        });
      } else {
        this.resources.gravar(this.evento).then(() => {
          this.$toast.create(this.$t('message.adicionado_confira_tabela'), 'snack', '3E3');
          this.$emit('atualizarGrid');
        }, (err) => {
          this.$error(this, err);
        });
      }
    },
    cancelar() {
      this.$refs.form.reset();
      this.$emit('cancelar');
    },
    isDataFimMaiorInicio() {
      const dtInicio = this.moment(this.evento.dataInicio, 'YYYY-MM-DD');
      const dtFinal = this.moment(this.evento.dataFim, 'YYYY-MM-DD');
      return dtFinal.isBefore(dtInicio);
    },
    isDataInicioMenorDiaSeguinte() {
      const dtInicio = this.moment(this.evento.dataInicio, 'YYYY-MM-DD');
      const dtDiaSeguinte = this.moment().add(1, 'd').format('YYYY-MM-DD');
      return dtInicio.isBefore(dtDiaSeguinte);
    },
    buscarTipos() {
      this.resources.tipos().then((response) => {
        this.tipos = response.data;
      }, (err) => {
        this.$error(this, err);
      });
    },
    carregar() {
      const id = this.idEvento;
      this.resources.obter({ id }).then((response) => {
        this.evento = response.data;
      }, (err) => {
        this.$error(this, err);
        this.cancelar();
      });
    },
    buscarEventos() {
      this.resources.listar().then((response) => {
        this.eventosListados = response.data.resposta;
      }, (err) => {
        this.$error(this, err);
        this.cancelar();
      });
    },
    exibeObservacoes(id) {
      const obj = this.tipos.find(el => el.id === id);
      if (obj) {
        this.observacoes = JSON.parse(obj.observacoes.value);
      }
    },
  },
  mounted() {
    this.buscarTipos();
    if (this.idEvento) {
      this.carregar();
      this.buscarEventos();
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/calendario/CalendarioForm.vue?vue&type=script&lang=js&